import { ActionTypes } from "../constants/action-types";

export const setPovrchy = (povrchy) => {
    return {
        type: ActionTypes.SET_POVRCHY,
        payload: povrchy
    };
};
export const setDoplnky = (doplnky) => {
    return {
        type: ActionTypes.SET_DOPLNKY,
        payload: doplnky
    };
};
export const setVybaveni = (vybaveni) => {
    return {
        type: ActionTypes.SET_VYBAVENI,
        payload: vybaveni
    };
};

export const selectedPovrch = (fullPovrch) => {
    return {
        type: ActionTypes.SELECTED_POVRCH,
        payload: fullPovrch
    };
};
export const removeSelectedPovrch = () => {
    return {
        type: ActionTypes.REMOVE_SELECTED_POVRCH
    };
};
export const selectedDoplnek = (fullDoplnek) => {
    return {
        type: ActionTypes.SELECTED_DOPLNEK,
        payload: fullDoplnek
    };
};
export const removeSelectedDoplnek = () => {
    return {
        type: ActionTypes.REMOVE_SELECTED_DOPLNEK
    };
};
export const selectedVybaveni = (fullVybaveni) => {
    return {
        type: ActionTypes.SELECTED_VYBAVENI,
        payload: fullVybaveni
    };
};
export const removeSelectedVybaveni = () => {
    return {
        type: ActionTypes.REMOVE_SELECTED_VYBAVENI
    };
};